module.exports = __webpack_public_path__ + "img/selected-etfhome_93a89.png";